module.exports = __webpack_public_path__ + "media/images/Minus-outline-9abed5be.svg";